import { render, staticRenderFns } from "./VolumeIndicator.vue?vue&type=template&id=72c5fdfa&scoped=true"
import script from "./VolumeIndicator.vue?vue&type=script&lang=js"
export * from "./VolumeIndicator.vue?vue&type=script&lang=js"
import style0 from "./VolumeIndicator.vue?vue&type=style&index=0&id=72c5fdfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5fdfa",
  null
  
)

export default component.exports